import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MapWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  padding: '0 20px 20px',
  height: '78vh',
  minHeight: '500px',
}));

export const MapPane = styled(Box)(({ theme }) => ({
  flex: '1 1 70%',
  position: 'relative',
  borderRadius: '8px',
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: '#EAEFF5',
  minHeight: '500px',
  '& .customMap': {
    width: '100%',
    height: '100%',
    minHeight: '500px',
  },
  '& .customMap > div:first-of-type': {
    width: '100%',
    height: '100%',
  },
}));

export const Sidebar = styled(Box)(({ theme }) => ({
  flex: '0 0 320px',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  overflow: 'hidden',
}));

export const SidebarHeader = styled(Box)(({ theme }) => ({
  padding: '12px 16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  fontWeight: 600,
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const SidebarList = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
  padding: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
}));

export const SidebarItem = styled(Box)(({ theme }) => ({
  padding: '8px 10px',
  borderRadius: '6px',
  border: `1px solid ${theme.palette.divider}`,
  cursor: 'pointer',
  fontSize: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  '&:hover, &:focus-visible': {
    backgroundColor: 'rgba(123, 63, 242, 0.06)',
    borderColor: theme.palette.primary.main,
    outline: 'none',
  },
  '& strong': { fontSize: '13px' },
  '& .meta': { color: '#666' },
}));

export const Banner = styled(Box)(() => ({
  position: 'absolute',
  top: '12px',
  left: '12px',
  right: '12px',
  zIndex: 5,
  padding: '8px 14px',
  borderRadius: '6px',
  backgroundColor: 'rgba(255, 244, 229, 0.95)',
  color: '#9A4F00',
  fontSize: '12px',
  fontWeight: 500,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
}));

export const Legend = styled(Box)(() => ({
  position: 'absolute',
  bottom: '12px',
  left: '12px',
  zIndex: 5,
  padding: '10px 14px',
  borderRadius: '6px',
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  fontSize: '12px',
  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
}));

export const LegendRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const LegendDot = styled('span')<{ color: string }>(({ color }) => ({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: color,
  display: 'inline-block',
}));

export const ColorByToggle = styled(Button)(({ theme }) => ({
  fontSize: '11px',
  padding: '4px 10px',
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  backgroundColor: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#F2EFFF',
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));

export const PinMarker = styled('div')<{ color: string }>(({ color }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  backgroundColor: color,
  border: '2px solid #fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
  transition: 'transform 0.1s',
  '&:hover': { transform: 'scale(1.15)' },
}));

export const Popover = styled(Box)(() => ({
  padding: '8px 10px',
  minWidth: '180px',
  fontSize: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  '& strong': { fontSize: '13px' },
  '& a': { color: '#7B3FF2', textDecoration: 'none', fontWeight: 600 },
}));
